/**
 * Product Title Formatter - Removes "Genius" from product titles
 */
document.addEventListener('DOMContentLoaded', function() {
  // Function to remove "Genius" from product titles
  function formatProductTitles() {
    // Find all product title elements
    const productTitles = document.querySelectorAll('.product-card__title a');
    
    productTitles.forEach(titleElement => {
      // Get the text content
      let titleText = titleElement.textContent.trim();
      
      // Replace "Genius " with empty string
      if (titleText.startsWith('Genius ')) {
        titleText = titleText.replace('Genius ', '');
        titleElement.textContent = titleText;
      }
    });
  }
  
  // Run initially
  formatProductTitles();
  
  // Run again after a short delay to ensure all elements are properly sized
  setTimeout(formatProductTitles, 100);
  
  // Set up a mutation observer to handle dynamically loaded content
  const observer = new MutationObserver(function(mutations) {
    let shouldFormat = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        shouldFormat = true;
      }
    });
    
    if (shouldFormat) {
      formatProductTitles();
    }
  });
  
  // Start observing the document body for DOM changes
  observer.observe(document.body, { 
    childList: true,
    subtree: true
  });
  
  // Also run on window resize to handle responsive layouts
  window.addEventListener('resize', formatProductTitles);
});
